module.exports = __webpack_public_path__ + "img/menu-warranty.fa662f95.svg";